const actionTypes = {
    GET_REPORTS_BY_GROUP_SUCCESS: 'GET_REPORTS_BY_GROUP_SUCCESS',
    GET_REF_DATA_REPORT_FIELD_MAPPING_SUCCESS: 'GET_REF_DATA_REPORT_FIELD_MAPPING_SUCCESS',
    GET_NEW_REPORT_FIELD_MAPPING_SUCCESS: 'GET_NEW_REPORT_FIELD_MAPPING_SUCCESS',
    GET_REPORT_RECON_MAPPINGS: 'GET_REPORT_RECON_MAPPINGS',
    GET_REPORT_GROUP_FIELD_EXPRESSION: 'GET_REPORT_GROUP_FIELD_EXPRESSION',
    RESET_REPORT_FIELD_MAPPING_SUCCESS: 'RESET_REPORT_FIELD_MAPPING_SUCCESS',
    GET_REPORTS_BY_EACH_GROUP_SUCCESS: 'GET_REPORTS_BY_EACH_GROUP_SUCCESS',
};

export default actionTypes;